import { render, staticRenderFns } from "./TeacherProfile.vue?vue&type=template&id=3fa0a912&"
import script from "./TeacherProfile.vue?vue&type=script&lang=js&"
export * from "./TeacherProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports